/**
 * A minor-unit amount in its own currency — `£1,250.00`, `€40.00`, `SEK 50.00`
 * (any well-formed code) — and for a code `Intl` rejects as malformed,
 * `12.50 POUNDS`. The ONE money formatter the Home
 * metrics and the /analytics checkout funnel share (2026-10-02), so the same
 * amount never reads two ways. A null currency reads as GBP, the Home card's
 * long-standing fallback.
 */
export function fmtMoney(minor: number, currency: string | null): string {
  const ccy = (currency ?? "GBP").toUpperCase();
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: ccy,
    }).format(minor / 100);
  } catch {
    return `${(minor / 100).toFixed(2)} ${ccy}`;
  }
}
